import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import './LCIResultDialog.css';
import moment from 'moment';

class LCIResultDialog extends Component {
  render () {
    const { type, name, langs, onClick, ...props } = this.props;

    if (type === 'PassFirstProblem') {
      return (
        <Modal
          {...props}
          footer={null}
          closable={false}
          width={565}
          centered
        >
          <p>Nice{name ? `, ${name}` : ''}! You&apos;ve successfully submitted your solution.</p>
          <p>Please solve the other problem for the remainder of the time. After solving that one,
            you will receive your Coding Challenge results and the next steps.</p>
          <div className="LCIResultDialog-action">
            <Button type="primary" onClick={onClick}>Take me to the other problem</Button>
          </div>
        </Modal>
      );
    }

    if (type === 'PracticeSubmittedAll') {
      return (
        <Modal
          {...props}
          footer={null}
          closable={false}
          width={565}
          centered
        >
          <p>Nice{name ? `, ${name}` : ''}! You&apos;ve submitted all solutions.</p>
          <p>You can retry this Practice coding challenge anytime.</p>
          <p>When you&apos;re confident, start the Real test.</p>
          <div className="LCIResultDialog-action">
            <Button type="primary" onClick={onClick}>Back to Instructions page</Button>
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        {...props}
        footer={null}
        closable={false}
        width={565}
        centered
      >

        {type === 'Pass' ? <p>Congrats, {name ? `${name}! ` : ''}You&apos;ve passed the Coding Challenge!</p> : null}
        {type === 'Pass' ? <p>You will start getting suggested for top U.S. jobs {langs ? `that require ${langs}` : ''}</p> : null}
        {type === 'Pass' ? <p>If you wish to maximize your job offers, please build your U.S. software engineering resume so that more companies can understand you better.</p> : null}

        {type === 'Fail' ? <p>Unfortunately, you didn&apos;t meet the minimum score to be considered for U.S. software engineering jobs.</p> : null}
        {type === 'Fail' ? <p>However, you can try this again in 3 months ({moment().add(3, 'months').format('LL')}). In the meantime, you will receive an email from us with study materials for your re-test.</p> : null}
        {type === 'Fail' ? <p>We hope to see you again soon.</p> : null}

        {type === 'Suspicious' ? <p>Congrats, {name ? `${name}! ` : ''}You&apos;ve submitted your Coding Challenge!</p> : null}
        {type === 'Suspicious' ? <p>We will review your submission and get back to you within 48 hours.</p> : null}
        {type === 'Suspicious' ? <p>In the meantime, we invite you to build your U.S. software engineering resume so that more companies can have an in-depth understanding of you.</p> : null}

        <div className="LCIResultDialog-action">
          <Button type="primary" onClick={onClick}>Close</Button>
        </div>
      </Modal>
    );
  }
}

LCIResultDialog.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  langs: PropTypes.string,
  onClick: PropTypes.func,
  visible: PropTypes.bool
};

LCIResultDialog.Pass = props => <LCIResultDialog {...props} type='Pass' />;
LCIResultDialog.Fail = props => <LCIResultDialog {...props} type='Fail' />;
LCIResultDialog.Suspicious = props => <LCIResultDialog {...props} type='Suspicious' />;
LCIResultDialog.PassFirstProblem = props => <LCIResultDialog {...props} type='PassFirstProblem' />;
LCIResultDialog.PracticeSubmittedAll = props => <LCIResultDialog {...props} type='PracticeSubmittedAll' />;

export default LCIResultDialog;
